import * as userActions from 'redux/actions/user.actions'
import * as accountActions from 'redux/actions/account.actions'
import moment from 'moment'

const initialState = {
  disabledFeatures: [],
  data: null,
  serverTime: null,
  clientTime: moment()
}

const accountReducer = (state = initialState, { type, payload = {} }) => {
  switch (type) {
    case accountActions.getAccountDataSuccess.type: {
      const { plan } = payload.data?.plan
      let disabledFeatures = []
      switch (true) {
        case /^standard/gi.test(plan):
          disabledFeatures = [
            'discovery',
            'savings',
            'keyword-finder',
            'serp-checker',
            'website-audit',
            'keyword-difficulty'
          ]
          break
        default:
          disabledFeatures = []
      }
      return {
        ...state,
        disabledFeatures,
        data: payload.data,
        serverTime: payload.data?.serverTime || null,
        clientTime: moment()
      }
    }
    case accountActions.getAccountDataFailure.type:
    case userActions.logout.type:
      return initialState
    default:
      return state
  }
}
export default accountReducer
